import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import Flex from 'components/ui/Flex';

type DescriptionCellProps = {
    label: string;
    isManualPrice?: boolean;
    isPercent?: boolean;
};

const DescriptionCell = ({ label, isManualPrice = false, isPercent = false }: DescriptionCellProps) => {
    const { t } = useTranslation();

    const getBadgeLabel = () => {
        if (isPercent && isManualPrice) return t('manualPercent');
        if (isPercent) return t('percentDeduction');
        if (isManualPrice) return t('manualPrice');
        return null;
    };

    const badgeLabel = getBadgeLabel();

    return (
        <Flex align="center" gap="0.5rem">
            <span>{label}</span>
            {badgeLabel && <ManualBadge>{badgeLabel}</ManualBadge>}
        </Flex>
    );
};

export default DescriptionCell;

const ManualBadge = styled.span`
    font-size: 10px;
    text-transform: uppercase;
    background-color: ${({ theme }) => theme.colors.main};
    color: ${({ theme }) => theme.colors.fillWhite};
    border-radius: var(--radius);
    padding: 0.1rem 0.4rem;
`;
